const validation = {
   requiredFieldText: '* Required',
   invalidEmailText: '* Invalid email address',
   maxUserNameLength: 200,
   maxNameLength: 200,
   maxProcessNameLength: 200,
   maxBlueprintNameLength: 200,
   maxBlueprintDescriptionLength: 200,
   maxDescriptionLength: 200,
   maxServiceDefintionLength: 500,
   maxProcessDescriptionLength: 200,
   maxRoleNameLength: 200,
   maxOrgNameLength: 200,
   maxWebsiteLength: 200,
   maxPhoneNumberLength: 30,
   maxAddressLength: 400,
   userOrgEntity: {
      minChatTokenMonthlyLimit: 0,
      maxChatTokenMonthlyLimit: 1_000_000_000,
   },
   orgEntity: {
      maxNameLength: 200,
      maxWebsiteLength: 100,
      maxPhoneNumberLength: 30,
      maxAddressLength: 200,
      maxTaxDescriptionLength: 50,
      minTaxPercentageLength: 0,
      maxTaxPercentageLength: 100,
      minTierMaxUsersLength: 1,
      maxTierMaxUsersLength: 1000,
      maxTimezoneLength: 100,
      maxTaxOrgIdLength: 2
   },
   userEntity: {
      maxFirstNameLength: 200,
      maxLastNameLength: 200,
   },
   workItemEntity: {
      maxNameLength: 200,
   },
   budgetEntity: {
      max: 1000000000000000,
   }
}

export default validation